import type { AIFeedback } from "../api/types";

/**
 * Coaching from the programme's AI reviewer. Labelled as advice: it never decides whether a step passes, the checks do.
 */
export function AIFeedbackCard({
  feedback,
  title = "AI coach",
}: {
  feedback: AIFeedback;
  title?: string;
}) {
  return (
    <div className="mt-3 rounded-[var(--radius-card)] border border-border bg-surface-high p-3.5 text-[13.5px]">
      <div className="mb-1 flex items-center justify-between gap-2">
        <b className="text-accent">{title}</b>
        <span className="text-[12px] text-text-muted">
          Advice only · client-eye score {feedback.score}/100
        </span>
      </div>
      {feedback.summary ? <p className="m-0">{feedback.summary}</p> : null}
      {feedback.strengths.length ? (
        <ul className="m-0 mt-2 pl-5">
          {feedback.strengths.map((item) => (
            <li key={item}>
              <span className="text-positive">✓</span> {item}
            </li>
          ))}
        </ul>
      ) : null}
      {feedback.improvements.length ? (
        <ul className="m-0 mt-2 pl-5">
          {feedback.improvements.map((item) => (
            <li key={item}>
              <span className="text-warning">→</span> {item}
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}
